/* eslint-disable ember/no-computed-properties-in-native-classes */
import Model, {
  attr,
  belongsTo,
  type AsyncBelongsTo,
} from '@warp-drive/legacy/model';
import { alias } from '@ember/object/computed';
import type { Type } from '@warp-drive/core/types/symbols';
import type { FragmentArray } from 'ember-data-model-fragments/array/fragment';
import { fragmentArray } from 'ember-data-model-fragments/attributes';
import type Event from '@linc-technologies/linced-common/models/events/event';
import type OptionCount from '@linc-technologies/linced-common/models/events/option-count';
import type School from '@linc-technologies/linced-common/models/school';

// Proto: events.EventCount.
export default class EventCount extends Model {
  declare [Type]: 'events/event-count';

  @belongsTo('school', { async: true, inverse: null })
  declare schoolId: AsyncBelongsTo<School>;

  @alias('schoolId')
  declare school: AsyncBelongsTo<School>;

  @alias('school.id')
  declare school_id: string | null | undefined;

  @attr('string', { defaultValue: '' })
  declare campusId: string;

  @attr('number')
  declare createTime: number | undefined;

  @attr('number')
  declare updateTime: number | undefined;

  @belongsTo('events/event', { async: true, inverse: 'eventCounts' })
  declare eventId: AsyncBelongsTo<Event>;

  @alias('eventId')
  declare event: AsyncBelongsTo<Event>;

  @attr('number', { defaultValue: 0 })
  declare currentAttendees: number;

  @fragmentArray('events/option-count')
  declare optionCounts: FragmentArray<OptionCount>;
}
